// src/lib/apiClient.js
import axios from "axios";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "/api"; // fallback rewrite Vercel

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
});

// Retry x2 sur erreurs réseau / timeout
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const retriable = ["ECONNABORTED", "ERR_NETWORK"].includes(error.code);
    if (!retriable) throw error;
    cfg.__retryCount = (cfg.__retryCount || 0) + 1;
    if (cfg.__retryCount > 2) throw error;
    const wait = 300 * 2 ** cfg.__retryCount; // 600ms, 1200ms
    await new Promise((r) => setTimeout(r, wait));
    return api(cfg);
  }
);

// Intercepteur de requête pour JWT automatique
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Log pour debugging
    if (process.env.NODE_ENV === 'development') {
      console.log(`🌐 API Call: ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`);
    }
    
    return config;
  },
  (error) => {
    console.error('❌ Erreur dans la configuration de la requête:', error);
    return Promise.reject(error);
  }
);

// Intercepteur de réponse pour gestion globale des erreurs
api.interceptors.response.use(
  (response) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`✅ API Response: ${response.status} ${response.config.url}`);
    }
    return response;
  },
  (error) => {
    console.error('❌ Erreur API:', error);
    
    // Gestion automatique des erreurs 401
    if (error.response?.status === 401) {
      console.warn('🔐 Token invalide ou expiré - redirection vers login');
      localStorage.removeItem('token');
      localStorage.removeItem('currentUser');
      
      window.dispatchEvent(new CustomEvent('auth:logout'));
      
      if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
        window.location.href = '/';
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;

// Helper si tu veux conserver apiPath:
export const apiPath = (p) => p.startsWith("/") ? p : `/${p}`;